export default function Estadisticas() {
  return <h2>Estadísticas (datos de prueba)</h2>;
}
